
export function groupBy(arr, key) {
  return arr.reduce((acc, obj) => {
    const groupKey = obj[key]
    acc[groupKey] = acc[groupKey] || []
    acc[groupKey].push(obj)
    return acc
  }, {})
}